import AppIcon from 'components/common/AppIcon/AppIcon';
import Button from 'components/common/Button';
import TextAreaInput from 'components/common/TextAreaInput';
import TextInput from 'components/common/TextInput';
import validationHelper from 'helpers/validationHelper';
import md5 from 'md5';
import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import dataService from 'services/dataService';
import styled from 'styled-components';
import {colors, containerStyles} from 'styles/shared';

const SupportContainer = styled.div`
  width: 54.4rem;
  height: 62.3rem;
  padding: 4.6rem 5rem 5rem;
  margin-bottom: 5rem;
  ${containerStyles};
`;

const Header = styled.div`
  font-size: 4rem;
  line-height: 4.8rem;
  color: ${colors.darkBlue_darker};
`;

const Text = styled.div`
  font-size: 1.8rem;
  line-height: 2.2rem;
  color: ${colors.darkBlue_main};
  margin-top: 1rem;
  margin-bottom: 4.3rem;
`;

const OverrideTextInput = styled(TextInput)`
  width: 100%;
  height: 8rem;

  .form-control {
    width: 100%;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const ResultContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const IconContainer = styled.div`
  width: 9.4rem;
  height: 9.4rem;
  background: ${colors.blue_lighter};
  border-radius: 50%;
  margin-top: 10.5rem;
  margin-bottom: 2.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Message = styled.div`
  font-weight: bold;
  font-size: 2rem;
  line-height: 2.4rem;
  color: ${colors.blue_main};
  width: 17.1rem;
  text-align: center;
  margin-bottom: 15.6rem;
`;

function SupportForm() {
  const [isFinished, setIsFinished] = useState(false);
  const [formData, setFormData] = useState({name: '', message: ''});
  const [errors, setErrors] = useState({name: '', message: ''});

  const user = useSelector((state: any) => state.user.current);

  function onChange(field, value) {
    setFormData({...formData, [field]: value});
  }

  function formIsValid() {
    let newErrors = {
      name: '',
      email: '',
      message: ''
    };

    if (!formData.name) {
      newErrors.name = 'Name field is required.';
    }

    if (!formData.message) {
      newErrors.message = 'Message field is required.';
    }

    setErrors(newErrors);

    return validationHelper.isEmptyErrorObject(newErrors);
  }

  async function sendMessage(e) {
    if (e) e.preventDefault();

    if (!isActiveButton()) return;

    if (!formIsValid()) return;

    setIsFinished(true);

    await dataService.sendContactMessage({
      email: user.email,
      ...formData,
      honeypot: md5(user.email)
    });
  }

  function sendAnotherMessage() {
    setFormData({name: '', message: ''});
    setIsFinished(false);
  }

  function isActiveButton() {
    return formData.name && formData.message ? true : false;
  }

  function renderResultScreen() {
    return (
      <ResultContainer>
        <IconContainer>
          <AppIcon name="success" />
        </IconContainer>

        <Message>Your message was successfully sent!</Message>

        <Button isActive={true} width={24.7} onClick={sendAnotherMessage}>
          Send another message
        </Button>
      </ResultContainer>
    );
  }

  function render() {
    let isActive = isActiveButton();

    return (
      <SupportContainer>
        <Header>Get in touch</Header>

        {isFinished ? (
          renderResultScreen()
        ) : (
          <>
            <Text>Leave us a message and we’ll get back to you as soon as possible.</Text>
            <OverrideTextInput
              name="name"
              value={formData.name}
              onChange={onChange}
              placeholder="Name"
              error={errors.name}
            />
            <TextAreaInput
              name="message"
              placeholder="Message"
              value={formData.message}
              onChange={onChange}
              error={errors.message}
            />
            <ButtonContainer>
              <Button isActive={isActive} width={24.7} onClick={sendMessage}>
                Send message
              </Button>
            </ButtonContainer>
          </>
        )}
      </SupportContainer>
    );
  }

  return render();
}

export default SupportForm;
